import {gql, useQuery} from '@apollo/client';
import {LoadingSpinner} from 'common';
import React, {ReactNode, useEffect} from 'react';
import {Route} from 'react-router-dom';

type TermOfServiceGuardProps = {
    children: ReactNode,
}
export const TermOfServiceGuard = ({children}: TermOfServiceGuardProps) => {
    if (process.env.REACT_APP_TOS_ENABLED === 'true') {
        return <EnabledCheck children={children}/>
    } else {
        return <>{children}</>
    }
};

const EnabledCheck = ({children}: TermOfServiceGuardProps) => {
    const {loading, data, error} = useQuery<{ latestTosAccepted: boolean }, {}>(
        gql`
            query checkMyTosStatus {
                latestTosAccepted
            }`,
    );
    if (error) {
        console.warn(`Error checking for ToS Status, will let user through: ${error}`);
    }

    if (loading) {
        return <LoadingSpinner spacing={20} centerScreen/>;
    }

    const latestTosAccepted = data?.latestTosAccepted ?? true;
    if (!latestTosAccepted) {
        return (<Route path="*" render={() => <RedirectToTermOfService/>}/>);
    }
    return <>{children}</>;
}
const RedirectToTermOfService = () => {
    useEffect(() => {
        window.location.href = `${process.env.REACT_APP_TOS_URL}/tos/check?redirectUrl=${window.location.href}`;
    }, []);
    return (
        <LoadingSpinner spacing={20} centerScreen/>
    );
}
